<div
  [style]="dropdownListStyle"
  [style.top]="reportDropDownList.top"
  [style.left]="reportDropDownList.left"
  [style.width]="reportDropDownList.width"
  [style.height]="reportDropDownList.height"
  [style.z-index]="reportDropDownList.zIndex"
  [style.border]="reportDropDownList.borderStyle"
  [style.border-color]="reportDropDownList.borderColor"
  [style.border-width]="reportDropDownList.borderWidth"
></div>
